module.exports = __webpack_public_path__ + "a3c25ab530d52a25af07e2a34cb2ebd8.jpg";